import { useLocalObservable } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps } from '@gem/popups';

import Tasks from 'APP/Tasks';

import { IWorkspaceFormData } from './EditWorkspaceForm/EditWorkspaceForm.presenter';

interface IEditWorkspacePopupPresenter {
  hasBackButton: boolean;
  submit(data: IWorkspaceFormData): Promise<void>;
  onClose(): void;
  onBack(): void;
}

export function useEditWorkspacePopupPresenter({
  popupInstance,
  onClose,
  onBack,
}: ICommonPopupsProps): IEditWorkspacePopupPresenter {
  const { t } = useTranslation();

  return useLocalObservable<IEditWorkspacePopupPresenter>(() => ({
    get hasBackButton(): boolean {
      return !!onBack;
    },

    async submit(data: IWorkspaceFormData): Promise<void> {
      const success = await Tasks.workspace.updateWorkspace(data);

      if (!success) {
        Tasks.app.showToast(t('something_went_wrong'));
      }

      this.onBack();
    },

    onClose(): void {
      popupInstance.close();
      onClose?.();
    },

    onBack(): void {
      popupInstance.close();
      onBack?.();
    },
  }));
}
